export default function AboutPage() {
  return (
    <div style={{ padding: "30px", maxWidth: "800px", margin: "0 auto" }}>
      <h1>Quem somos</h1>

     <p>
A Shopping World MTI é uma plataforma digital criada para conectar pessoas às melhores oportunidades de compra online, com uma experiência simples, rápida e inteligente.
</p>

<p>
Reunimos produtos de lojas como SHEIN Brasil, Amazon Brasil, Amazon USA e Mercado Livre Brasil em um só lugar, facilitando a busca inteligente, comparação e acesso direto às melhores ofertas disponíveis no mercado.
</p>

<p>
⚠️ <strong>Importante:</strong> As compras realizadas nas lojas brasileiras (SHEIN Brasil, Amazon Brasil e Mercado Livre) são destinadas exclusivamente para pessoas que se encontram no Brasil.
</p>

<p>
🌎 Já os produtos da <strong>Amazon USA</strong> são indicados para usuários que estão localizados nos Estados Unidos, garantindo uma melhor experiência de entrega e disponibilidade dos produtos.
</p>

<p>
Além disso, oferecemos a oportunidade para que qualquer pessoa se torne uma afiliada, compartilhando produtos e gerando renda através de comissões.
</p>

<p>
Nosso objetivo é simplificar a experiência de compra e, ao mesmo tempo, criar oportunidades reais de crescimento financeiro para nossa comunidade.
</p>

<p>
<strong>Shopping World MTI: seu shopping digital inteligente, tudo em um só lugar.</strong>
</p>
    </div>
  );
}